import axiosInstance from "@/api/axiosInstance";
import { ReviewQueueRow } from "@/modules/growthStages/features/Diagnostics/types/diagnostic";

interface Response {
  attempts: ReviewQueueRow[];
}

export const listAwaitingReviewAttempts = async (): Promise<
  ReviewQueueRow[]
> => {
  const response = await axiosInstance.get<Response>(
    "/api/private/attempts/in-progress",
  );
  return response.data.attempts;
};
